import { Observable } from '@apollo/client';

import AuthService from '../services/AuthService';

export default function handleUnauthorizedError(operation, forward) {
  return new Observable((observer) => {
    let subscription;
    AuthService.refreshAccessToken()
      .then((newAccessToken) => {
        const oldHeaders = operation.getContext().headers;

        operation.setContext({
          headers: {
            ...oldHeaders,
            authorization: `Bearer ${newAccessToken}`,
          },
        });

        subscription = forward(operation).subscribe({
          next: observer.next.bind(observer),
          error: observer.error.bind(observer),
          complete: observer.complete.bind(observer),
        });
      })
      .catch((e) => {
        observer.error(e);
      });

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  });
}
